export default __webpack_public_path__ + "static/media/Snd_ClowerZ.2dd3def6.mp3";